import { Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import TextField, { type TextFieldProps } from '@mui/material/TextField';

import type { AllRepeatDetails } from '../Repeat.types';

type IntervalTextInputProps = {
  value: AllRepeatDetails;
  onChange: (value: AllRepeatDetails) => void;
  unit: string;
  pluralizeUnit?: boolean;
  inputSize: TextFieldProps['size'];
  inputVariant: TextFieldProps['variant'];
};

const IntervalTextInput = ({
  value,
  onChange,
  unit,
  pluralizeUnit,
  inputSize,
  inputVariant,
}: IntervalTextInputProps) => (
  <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
    <Typography sx={{ fontSize: inputSize }}>Every</Typography>
    <TextField
      id="outlined-basic"
      label=""
      type="number"
      value={value.interval}
      size={inputSize}
      variant={inputVariant}
      onChange={(e: { target: { value: string } }) =>
        onChange({ ...value, interval: Number.parseInt(e.target.value, 10) })
      }
      slotProps={{ htmlInput: { min: 1 } }}
    />
    <Typography sx={{ fontSize: inputSize }}>{`${unit}${pluralizeUnit ? '(s)' : ''}`}</Typography>
  </Stack>
);

export default IntervalTextInput;
